import { SortableElement } from "react-sortable-hoc";

import Service from "./Service";

export default SortableElement(Service);
